import React, { useState } from "react";

import {
    Mail,
    Phone,
    MapPin,
    Instagram,
    Facebook,
    Linkedin,
    MessageCircle,
    Smartphone,
} from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';






const Contact = () => {
const [loading, setLoading] = useState(false);

 const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
            setLoading(true);  // Start loading


        try {
            const response = await fetch("https://100billionrealestate.com/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                toast.success("Message sent successfully! ");
                setFormData({ name: "", email: "", phone: "", message: "" });
            } else {
                toast.error("Failed to send message. Try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
        setLoading(false);  // Stop loading
    }
    };

    return (
        <section className="bg-[--neutral-light-gray] py-24 px-6">
                        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

            <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-start">
                {/* Left Side: Contact Info */}
                <div className="space-y-8">
                    <div className="space-y-4">
                        <h1 className="text-4xl font-extrabold text-[--primary-wine]">
                            Get in Touch 🍷
                        </h1>
                        <p className="text-lg text-gray-600">
                            Connect with Ronnie Victor Carneiro and the Carneiro Wine family. We're here for your wine inquiries and connections.
                        </p>
                    </div>
                    <div>
                        <h2 className="text-xl font-semibold text-[--primary-wine]">Address:</h2>
                        <p className="text-gray-800 leading-relaxed">
                            Mulgaon Dhondodi Wadi,
                            Domnic Carneiro Road Marg,
                            Near Mulgaon Church,
                            Vasai 401201 (West),
                            District Palghar, Maharashtra
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-[--primary-wine]">Contact:</h2>
                        <p className="text-gray-800 flex items-center gap-2">
                            <Phone size={18} className="text-[--primary-wine]" />
                            WhatsApp / Telegram:{" "}
                            <a
                                href="https://wa.me/+919881055454"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[--primary-wine] font-medium"
                            >
                                +91 98810 55454
                            </a>
                        </p>
                        <p className="text-gray-800 flex items-center gap-2">
                            <Mail size={18} className="text-[--primary-wine]" />
                            Email:{" "}
                            <a
                                href="mailto:ronnie@carneriowine.com"
                                className="text-[--primary-wine] font-medium"
                            >
                                ronnie@carneriowine.com
                            </a>
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold text-[--primary-wine]">Follow Us:</h2>
                        <ul className="space-y-2 flex flex-wrap items-end gap-2">
                            <li>
                                <a href="https://www.facebook.com/carneirowine/" target="_blank" className="flex items-center gap-2 hover:text-[--primary-wine]">
                                    <Facebook size={18} /> Facebook
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/carneirowine/" target="_blank" className="flex items-center gap-2 hover:text-[--primary-wine]">
                                    <Instagram size={18} /> Instagram
                                </a>
                            </li>
                            {/* <li>
                                <a href="https://www.linkedin.com/company/107906905/admin/page-posts/published/" target="_blank" className="flex items-center gap-2 hover:text-[--primary-wine]">
                                    <Linkedin size={18} /> LinkedIn
                                </a>
                            </li> */}
                            <li>
                                <a href="https://teams.live.com/l/invite/FEA2R-JRHuJV4W6XgI" target="_blank" className="flex items-center gap-2 hover:text-[--primary-wine]">
                                    <MessageCircle size={18} /> Teams Invite
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Right Side: Contact Form */}
                <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-xl p-8 space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Your name"
                            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            type="email"
                             name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="you@example.com"
                            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Phone</label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="+91 98765 43210"
                            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Message</label>
                        <textarea
                          name="message"
                            rows="4"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Tell us how we can help..."
                            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md resize-none focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                            disabled={loading}

                        className="w-full bg-[--primary-wine] text-white font-semibold py-3 rounded-md hover:bg-[--primary-wine-hover] transition"
                    >
    {loading ? "Sending..." : "Send Message"}
                    </button>
                </form>
            </div>
        </section>
    );
};

export default Contact;
